module.exports = __webpack_public_path__ + "static/img/u11.7eaf1f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u11.png
// module id = 4BxC
// module chunks = 0